'use client';

import { usePathname } from 'next/navigation';
import { useFeatureFlag } from '@/app/hooks/useFeatureFlag';
import { GUIDE_CHAT_FEATURE_FLAG } from '@/app/lib/guideChat/flag';
import { guideChatScopeForPath } from '@/app/lib/guideChat/triggers';
import GuideChatWidget from './GuideChatWidget';

export { GUIDE_CHAT_FEATURE_FLAG };

// The assistant lives on the guide cocoons of the products it covers, plus the loan landing and comparator pages.
export default function GuideChatMount() {
  const pathname = usePathname() ?? '';
  const enabled = useFeatureFlag(GUIDE_CHAT_FEATURE_FLAG);
  const scope = guideChatScopeForPath(pathname);
  if (!enabled || !scope) return null;
  return <GuideChatWidget key={pathname} kind={scope.kind} product={scope.product} />;
}
